import { SspBean, SspControllerApi, ItemResponseSspBeanObject, ListResponseSspBean } from 'src/api/api'
import { BaseApi, configuration } from '../../../api/BaseApi'

class SspApi extends BaseApi {
    api: SspControllerApi

    constructor() {
        super()
        this.api = new SspControllerApi(configuration, configuration.basePath, this.fetch)
    }

    async list(size: number = 20, page: number = 1, sort, search, type, active): Promise<ListResponseSspBean> {
        return this.call(() => this.api.sspList(search, type, active, { query: { size, page, sort } }))
    }

    async all(): Promise<ListResponseSspBean> {
        return this.call(() => this.api.sspList())
    }

    async create(ssp: SspBean): Promise<ItemResponseSspBeanObject> {
        return this.call(() => this.api.createSsp(ssp))
    }

    async edit(id: any, ssp: SspBean): Promise<ItemResponseSspBeanObject> {
        return this.call(() => this.api.editSsp(ssp, id))
    }

    async view(id: any): Promise<ItemResponseSspBeanObject> {
        return this.call(() => this.api.ssp(id))
    }

    async delete(id: any): Promise<void> {
        return this.call(() => this.api.deleteSsp(id))
    }

    async activate(id: any): Promise<void> {
        return this.call(() => this.api.activateSsp(id))
    }
}

const sspApi = new SspApi()
export default sspApi


// WEBPACK FOOTER //
// ./src/component/app/ssp/SspApi.ts